import { useMemo } from "react";
import { mixed, object, string } from "yup";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.SettlementDate]: mixed()
                .required()
                .label('Settlement Date'),

            [FormField.Mor]: string()
                .required()
                .nullable()
                .label('MOR'),

            [FormField.Psp]: string()
                .required()
                .nullable()
                .label('PSP'),

            [FormField.CsvSeparator]: string()
                .required()
                .label('CSV Separator'),

            [FormField.File]: mixed()
                .required()
                .nullable()
                .label('File')
        })
    ), []);

export default useValidationSchema;
